const hasUppercase = (value: string) => /^(?=.*[A-Z]){1}/.test(value);

export default hasUppercase;
